import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UCBerkeley = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of California, Berkeley"
      universityShortName="UC Berkeley"
      slug="uc-berkeley"
      seoTitle="UC Berkeley Study Rooms | Gardner Stacks and Moffitt Library Study Spaces"
      seoDescription="Find study rooms at UC Berkeley including Gardner Main Stacks and Doe Library. Learn booking policies and discover CSW as an online alternative."
      seoKeywords="UC Berkeley study rooms, Gardner Stacks, Moffitt Library, Berkeley study spaces, Golden Bear study rooms"
      canonicalUrl="/study-room/uc-berkeley/"
      heroDescription="Explore Berkeley's iconic libraries from the Gardner Stacks to the historic Doe Library."
      libraryWebsiteUrl="https://www.lib.berkeley.edu"
      libraryWebsiteName="UC Berkeley Library"
      studySpaces={[
        {
          name: "Gardner Main Stacks - Group Rooms",
          features: "4 large rooms (8-10 seats), 13 smaller (4-5 seats). Chalkboards, Wi-Fi. 2x 2-hour sessions/day, book 7 days ahead.",
          feedback: "Keys at circulation desk. Check in within 15 minutes."
        },
        {
          name: "Moffitt Library - Fifth Floor",
          features: "Late-night quiet floor, designated silent study.",
          feedback: "Only late-night quiet floor. Can be noisy - people urged to respect rules."
        },
        {
          name: "Doe Library - Morrison Reading Room",
          features: "Historic reading room, quiet individual study.",
          feedback: "Beautiful space for focused work. Very quiet atmosphere."
        },
        {
          name: "Gardner Stacks - General",
          features: "Deep stacks with individual carrels and desks.",
          feedback: "Ultimate quiet in the depths. Can feel isolated."
        }
      ]}
      guideContent={
        <>
          <p>
            At UC Berkeley's Gardner Main Stacks, group study rooms are available to UCB students and faculty. 
            Keys can be checked out at the circulation desk; students may reserve two 2-hour sessions per day 
            with bookings up to seven days in advance.
          </p>
          <p className="mt-4">
            There are four large rooms seating 8-10 and 13 smaller rooms seating 4-5; rooms contain chalkboards 
            and Wi-Fi. Reservations are cancelled if not claimed within 15 minutes.
          </p>
          <p className="mt-4">
            Students complain that the fifth floor of Moffitt Library (the only late-night quiet floor) is often noisy; 
            they urge peers to respect the quiet floor and move conversations elsewhere. Reserve Gardner rooms early 
            and bring your own markers for the chalkboard. For a quiet environment, head to Doe Library's Morrison 
            Reading Room or Moffitt fifth floor outside peak hours. Bring earplugs to counter occasional noise.
          </p>
        </>
      }
      summaryTips={[
        "Book 2x 2-hour sessions per day, 7 days ahead",
        "Pick up keys at circulation desk",
        "15-minute check-in or reservation cancelled",
        "Gardner rooms have chalkboards - bring markers",
        "Morrison Reading Room in Doe is very quiet"
      ]}
    />
  );
};

export default UCBerkeley;
